<ion-header mode="md">
  <ion-toolbar class="ion-text-center">
    <ion-item lines="none">
      <ion-img class="logo" src="../assets/images/app-logo.svg"></ion-img>
    </ion-item>
  </ion-toolbar>
</ion-header>

<ion-content full>
  <ion-grid class="box">
    <ion-row class="content-padding-vertical">
      <ion-col [ngClass]="{'reset-padding': !sended}">
        <app-email-sended-message
          *ngIf="sended"
          header="AUTH.RESET_PASSWORD"
          descriptionStart="AUTH.RESET_PASSWORD_MESSAGE_SENT_START"
          descriptionEnd="AUTH.RESET_PASSWORD_MESSAGE_SENT_END"
          [userEmail]="authService.emailAddressSended"
        ></app-email-sended-message>

        <div *ngIf="!sended" class="">
          <ion-fab class="back">
            <ion-fab-button href="/auth" size="small">
              <ion-icon name="chevron-back-outline"></ion-icon>
            </ion-fab-button>
          </ion-fab>
          <ion-item class="input header" lines="none">
            <h3>{{'AUTH.RESET_PASSWORD' | translate}}</h3>
          </ion-item>
          <p class="small">{{'AUTH.RESET_PASSWORD_INFO' | translate}}</p>
          <p class="small">{{'AUTH.RESET_PASSWORD_INFO_CD' | translate}}</p>
          <form [formGroup]="form">
            <app-input
              type="input"
              [form]="form"
              formControlName="email"
              label="SETTINGS.EMAIL"
              [submittedError]="validationError"
            ></app-input>

            <app-input *ngIf="!isSubdomain"
              type="input"
              [form]="form"
              formControlName="appName"
              label="AUTH.LOCATION"
              [submittedError]="validationError"
            ></app-input>

            <ion-button
              class="forgot-password-button"
              (click)="save()"
              size="large"
              expand="block"
              >{{'AUTH.BUTTON_CONFIRM' | translate}}</ion-button
            >
          </form>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
